import { getCurrentLang } from './get-current-lang';

export const composePath = (path: string): string => {
  const currentLang = getCurrentLang();

  const trimmedPath = path.startsWith('/') ? path.substring(1) : path;

  return `/${currentLang}/${trimmedPath}`;
};
